import { useEffect, useRef } from "react";
import { TAREFAS_AUTO_REFRESH_MS } from "@/config/constants";

type LoadFn = (opts?: { silent?: boolean; reportError?: boolean }) => void | Promise<void>;

/** Reutiliza o intervalo de Tarefas (30s) para dados operacionais compartilhados. */
export function useLocacoesAutoRefresh(load: LoadFn, paused = false): void {
  const loadRef = useRef(load);
  loadRef.current = load;
  const pausedRef = useRef(paused);
  pausedRef.current = paused;

  useEffect(() => {
    const tick = () => {
      if (pausedRef.current) return;
      void Promise.resolve(loadRef.current({ silent: true, reportError: true })).catch(() => {
        // load() já exibiu a mensagem via setError quando reportError é true.
      });
    };
    const intervalId = window.setInterval(tick, TAREFAS_AUTO_REFRESH_MS);
    const onVisibility = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
}
